module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "header",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showSection ? _vm.showSection = null : _vm.showSection = 'assignments'
      }
    }
  }, [_c('h4', [_vm._v("Assignments")]), _vm._v(" "), (_vm.showSection === 'assignments') ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _c('i', {
    staticClass: "fa fa-caret-right"
  })]), _vm._v(" "), (_vm.showSection === 'assignments') ? _c('div', {
    staticClass: "table-wrapper nice-scrollbar"
  }, [(_vm.assignments) ? _c('div', _vm._l((_vm.assignments), function(assignments, term) {
    return _c('div', [_c('h5', [_vm._v(_vm._s(term))]), _vm._v(" "), _c('table', [_vm._m(0, true), _vm._v(" "), _c('tbody', _vm._l((assignments), function(assignment) {
      return _c('tr', [_c('td', [(assignment.instance) ? _c('span', [_vm._v("\n                                    " + _vm._s(assignment.instance.associated.name) + "\n                                ")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v("Week " + _vm._s(assignment.week))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(assignment.name))]), _vm._v(" "), _c('td', [(assignment.instance) ? _c('span', [_vm._v(_vm._s(assignment.instance.path))]) : _vm._e()])])
    }))])])
  })) : _c('div', [_c('Loader')], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "header",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showSection ? _vm.showSection = null : _vm.showSection = 'exercises'
      }
    }
  }, [_c('h4', [_vm._v("Exercises")]), _vm._v(" "), (_vm.showSection === 'exercises') ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _c('i', {
    staticClass: "fa fa-caret-right"
  })]), _vm._v(" "), (_vm.showSection === 'exercises') ? _c('div', {
    staticClass: "table-wrapper nice-scrollbar"
  }, [(_vm.exercises) ? _c('div', _vm._l((_vm.exercises), function(exercises, term) {
    return _c('div', [_c('h5', [_vm._v(_vm._s(term))]), _vm._v(" "), _c('table', [_vm._m(1, true), _vm._v(" "), _c('tbody', _vm._l((exercises), function(exercise) {
      return _c('tr', [_c('td', [(exercise.video && exercise.video.course_instance) ? _c('span', [_vm._v("\n                                    " + _vm._s(exercise.video.course.name) + "\n                                ")]) : _vm._e()]), _vm._v(" "), (exercise.video) ? _c('td', [_vm._v("Week " + _vm._s(exercise.video.week))]) : _c('td', [_vm._v("NO VIDEO")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(exercise.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(exercise.path))])])
    }))])])
  })) : _c('div', [_c('Loader')], 1)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("\n                                Course\n                            ")]), _vm._v(" "), _c('th', [_vm._v("\n                                Week\n                            ")]), _vm._v(" "), _c('th', [_vm._v("\n                                Name\n                            ")]), _vm._v(" "), _c('th', [_vm._v("\n                        \t    Path\n                        \t")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("\n                                Course\n                            ")]), _vm._v(" "), _c('th', [_vm._v("\n                                Week\n                            ")]), _vm._v(" "), _c('th', [_vm._v("\n                                Name\n                            ")]), _vm._v(" "), _c('th', [_vm._v("\n                            \tPath\n                            ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c3b8ea84!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/WatermarkedFiles.vue
// module id = 2125
// module chunks = 2